let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kRZrj")).then(() => parcelRequire('3WoWv'));